import { render, staticRenderFns } from "./adminClientSettings.vue?vue&type=template&id=41a9ec32&scoped=true&"
import script from "./adminClientSettings.vue?vue&type=script&lang=js&"
export * from "./adminClientSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a9ec32",
  null
  
)

export default component.exports